import styled from 'styled-components';
import Radio from 'antd/es/radio';
import { Colors, FontSizes } from 'core/CssVariables';

const SRadio = styled(Radio)`
  .ant-radio-inner {
    background-color: ${props => props.theme.radio.backgroundColor};
    border-color: ${Colors.Grey};
  }
  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: none;
  }
  .radio-label {
    line-height: 21px;
    font-size: ${FontSizes.FontSM}px;
    color: ${props => props.theme.radio.label};
  }
  .ant-radio-disabled .ant-radio-inner {
    border-color: ${Colors.Grey}4D !important;
  }
`;

export default SRadio;
